import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import { isMiniSize as isMiniSizeMethod, debounce } from "@/utils";

class LoadMore extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMiniSize: false,
    };

    this.resizeDebounce = debounce(this.resize);
  }

  componentDidMount() {
    this.resize();
    window.addEventListener("resize", this.resizeDebounce);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeDebounce);
    this.resizeDebounce.cancel();
  }

  resize = () => {
    this.setState({
      isMiniSize: isMiniSizeMethod(),
    });
  };

  click = () => {
    const {
      to,
      history: { push },
    } = this.props;
    push(to);
  };

  render() {
    const { text, t } = this.props;
    const { isMiniSize } = this.state;
    return (
      <div className="load-more-main-container">
        {isMiniSize && (
          <button className="load-more-container" onClick={this.click}>
            {text || t("TWBC0001_more")}
          </button>
        )}
      </div>
    );
  }
}

LoadMore.propTypes = {
  to: PropTypes.object.isRequired,
  text: PropTypes.string,
};

LoadMore.defaultProps = {
  text: "",
};

export default withRouter(withTranslation()(LoadMore));
